import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const eventDelayUiNodeSpec: UiNodeSpec<'eventDelay'> = {
    requiredSockets: 'all',
    cfg: () => ({ controlValues: { delayMs: 1000 }, id: getUID(), kind: 'eventDelay', disabled: false }),
    controls: getNodeCfg => ({ delayMs: { cfg: { kind: 'number', label: 'Delay (ms)', min: 0 }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.delayMs } }),
    inputs: () => ({ input: { socket: 'event', label: 'Input' } }),
    kindLabel: 'Event Delay',
    nodeCategory: 'events',
    outputs: () => ({ output: { socket: 'event', label: 'Output' } }),
    validator: () => true,
};
